/**
 * Bevestiging voor het verwijderen van een login of chatter.
 *
 * 30-09-2026 (Jordy): verwijderen is in het scherm definitief, dus eerst de
 * naam overtypen. Wat er wel en niet meegaat staat erbij; de aanroeper geeft
 * de waarschuwingen mee (sub-chatters, open saldo, gekoppelde login).
 */
import { useState, type ReactNode } from 'react'
import { Field, Modal } from './Modal'
import { useActions } from '../lib/actions'

export function VerwijderDialog({
  titel,
  naam,
  children,
  request,
  onDone,
  onClose,
}: {
  titel: string
  /** Wat de gebruiker moet overtypen. */
  naam: string
  children?: ReactNode
  request: () => Promise<unknown>
  onDone: () => void
  onClose: () => void
}) {
  const { run, busy } = useActions()
  const [getypt, setGetypt] = useState('')
  const klopt = getypt.trim() === naam.trim()

  return (
    <Modal
      title={titel}
      desc="This cannot be undone from the dashboard."
      width={560}
      onClose={onClose}
      footer={
        <>
          <button className="btn ghost sm" type="button" onClick={onClose}>Cancel</button>
          <button
            className="btn danger sm"
            type="button"
            disabled={!klopt || busy === titel}
            onClick={async () => {
              const gelukt = await run({ label: titel, request, successText: `${naam} deleted` })
              if (gelukt) { onDone(); onClose() }
            }}
          >
            Delete permanently
          </button>
        </>
      }
    >
      {children}
      <Field label={`Type "${naam}" to confirm`}>
        <input className="inp" value={getypt} autoComplete="off"
               onChange={(e) => setGetypt(e.target.value)} />
      </Field>
    </Modal>
  )
}
